import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Dialog } from 'primeng/dialog';
import { OperationSubmission } from '../../../../models/operation-submission';
import { OperationSubmissionService } from '../../../../services/operation-submissions/operation-submission-service';

export type OperationReviewAction = 'approve' | 'reject';

// Approve or reject dialog for operation photos; reuses the end-ride photo dialog styles
@Component({
  selector: 'app-review-operation-submission-form',
  imports: [Dialog, FormsModule],
  templateUrl: './review-operation-submission-form.html',
  styleUrls: [
    '../../rides/approve-end-ride-photos-form/approve-end-ride-photos-form.scss',
    '../../rides/reject-end-ride-photos-form/reject-end-ride-photos-form.scss',
  ]
})
export class ReviewOperationSubmissionForm {

  @Output() reviewed = new EventEmitter<OperationSubmission>();
  @Output() visibilityChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input({ required: true }) submission: OperationSubmission
  @Input({ required: true }) action: OperationReviewAction

  @Input()
  public get visibility() {
    return this._visibility
  }

  public set visibility(value: boolean) {
    this._visibility = value
    this.visibilityChange.emit(value)
  }

  _visibility = false
  loading = false
  comment = ''

  private operationSubmissionService = inject(OperationSubmissionService)

  get isApprove(): boolean {
    return this.action === 'approve'
  }

  // Class prefix of the reused stylesheet: apd = approve, rpd = reject
  get p(): string {
    return this.isApprove ? 'apd' : 'rpd'
  }

  submit = () => {
    if (!this.submission) return

    this.loading = true
    const payload = this.comment.trim() ? { comment: this.comment.trim() } : {}
    const request$ = this.isApprove
      ? this.operationSubmissionService.approve(this.submission.id, payload)
      : this.operationSubmissionService.reject(this.submission.id, payload)

    request$.subscribe({
      next: () => {
        this.reviewed.emit(this.submission)
        this.loading = false
        this.comment = ''
      },
      error: () => {
        this.loading = false
      }
    })
  }

  cancel = () => {
    this.comment = ''
    this.visibilityChange.emit(false)
  }
}
